export default __webpack_public_path__ + "static/media/smoke.7c256a05.png";